import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ComponentStatus } from 'bom/enums';
import { ActionButton } from 'core/components';
import { ActionButtonType } from 'core/enums';
import { useAgGridTableContext, useNotificationContext } from 'core/states';
import { IJobPart } from 'jobs/types';
import { ExternalPartStatusType } from 'parts/enums';
import { QuoteEntityType, QuoteType } from 'quotes/enums';
import { Color, Variant } from 'theme/enums';

import { AddToQuote } from './AddToQuote';

export const AddToQuoteButton = () => {
  const [addToQuoteType, setAddToQuoteType] = useState<QuoteType | null>(null);

  const { t } = useTranslation();

  const { selectedRows, deselectAllRows } = useAgGridTableContext();
  const { isLoadingTopNotificationDisplayed } = useNotificationContext();

  const entityType = QuoteEntityType.QUOTE;

  const isDisabled = useMemo(
    () =>
      isLoadingTopNotificationDisplayed ||
      selectedRows.some((jobPart: IJobPart) => jobPart.status === ComponentStatus.DELETED) ||
      selectedRows.every(
        (jobPart: IJobPart) => jobPart.externalPartStatus === ExternalPartStatusType.ABANDONED
      ),
    [isLoadingTopNotificationDisplayed, selectedRows]
  );

  const onClose = () => setAddToQuoteType(null);

  const onSubmitSuccess = () => deselectAllRows();

  return (
    <>
      <ActionButton
        action={{
          type: ActionButtonType.MENU,
          label: t('buttonLabelAddToQuote', { entityType }),
          color: Color.NEUTRAL,
          variant: Variant.OUTLINED,
          menuItems: [
            {
              label: t('buttonLabelAddToCustomerQuote', { entityType }),
              onClick: () => setAddToQuoteType(QuoteType.CUSTOMER),
            },
            {
              label: t('buttonLabelAddToVendorQuote', { entityType }),
              onClick: () => setAddToQuoteType(QuoteType.VENDOR),
            },
          ],
          disabled: isDisabled,
        }}
      />

      {!isDisabled && (
        <AddToQuote
          addToQuoteType={addToQuoteType}
          onClose={onClose}
          onSubmitSuccess={onSubmitSuccess}
        />
      )}
    </>
  );
};
